import react from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Header from "../general/Header";
import Footer from "../general/Footer";

function ConfirmacionCuestionario() {
    

    const queryParams = useLocation().search;

    const [idPaciente, setIdPaciente] = useState(new URLSearchParams(queryParams).get('id'));
    const [emailPaciente, setEmailPaciente] = useState(new URLSearchParams(queryParams).get('email'));
    const [tokenPaciente, setTokenPaciente] = useState(new URLSearchParams(queryParams).get('token'));

    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();

    let history = useHistory();

    let userdata = [];

    useEffect(() => {

        
    },[]);


    return (
            <div className="hold-transition" style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%',height:'100vh'}}>
                <h1 className="m-0">¡Gracias por tu colaboración!</h1>
                {/*<div className="row">
                    <div className="col-md-2">
                    </div>
                    <div className="col-md-8">
                        <div className="row mb-2" style={{marginTop:'30px'}}>
                            <h1 className="m-0" style={{textAlign: 'center', width: '100%'}}>¡Gracias por tu colaboración!</h1>
                        </div>

                    </div>
                </div>*/}
            </div>
    );
}
export default ConfirmacionCuestionario;